import React, { FunctionComponent, memo } from 'react';
import { Grid } from '@material-ui/core';
import IExtendedFeaturesList from '../../../../../../model/IExtendedFeaturesList';
import featureAccessoryListStyles from './featureAccessoryListStyles';
import FeatureAccessory, { FeatureAccessoryOrientation } from '../FeatureAccessory';
import ICategoryAttributes from '../../../../../../model/ICategoryAttributes';
import { useCheckSelectedFeatures } from '../../../../../../hooks/features/useCheckSelectedFeatures';
import ViewMoreCta from '../../../../../../../gqlCommon/components/presentation/viewMoreCTA/ViewMoreCTA';
import useViewMoreElements from '../../../../../../../gqlCommon/hooks/useViewMoreElements';
import IFeature from '../../../../../../model/IFeature';
import customise from '../../../../../../constants/customise';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

export interface IFeaturesListProps {
  featuresList: IExtendedFeaturesList;
  categoryAttributes?: ICategoryAttributes;
  layoutOrientation?: FeatureAccessoryOrientation;
  openAccessoryDetailsModal: (value: boolean, feature: IFeature) => void;
}

const FeatureAccessoryList: FunctionComponent<IFeaturesListProps> = memo(
  ({
    featuresList,
    categoryAttributes,
    layoutOrientation = FeatureAccessoryOrientation.PORTRAIT,
    openAccessoryDetailsModal,
  }) => {
    const { optimisticSelectedFeatures: selectedFeaturesId } = useCustomizeCarContext();
    const styles = featureAccessoryListStyles();
    const { handleCheckboxChange } = useCheckSelectedFeatures();
    const { currentIndex, incrementViewMoreCount, shouldRenderCTA } = useViewMoreElements(
      categoryAttributes?.viewnumberoffeatures === customise.ALL
        ? null
        : parseInt(categoryAttributes?.viewnumberoffeatures),
      featuresList.features.length,
    );

    return (
      <Grid className={styles.container} container={true}>
        {featuresList.features.map((feature, index) => {
          if (currentIndex && index >= currentIndex) {
            return null;
          }

          return (
            <FeatureAccessory
              key={feature.code}
              id={feature.code}
              feature={feature}
              onClick={handleCheckboxChange}
              isSelectedFeature={!!selectedFeaturesId?.includes(feature.code)}
              categoryAttributes={categoryAttributes}
              orientation={layoutOrientation}
              openAccessoryDetailsModal={openAccessoryDetailsModal}
            />
          );
        })}
        {shouldRenderCTA && <ViewMoreCta onClick={incrementViewMoreCount} />}
      </Grid>
    );
  },
);

export default FeatureAccessoryList;
